module.exports = __webpack_public_path__ + "img/pethouse39.e1cf3518.jpg";